import { Form, Button, Col, Row, InputGroup, Table } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useState, useEffect } from 'react';
import { FaDownload, FaEdit, FaFileDownload, FaTrash } from 'react-icons/fa';
import InfoTooltip from '../../core/ToolTip';
import axios from "axios";
import { SpinnerModal, generateYears, getFiscalYear } from '../Util';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';

export default function OperationalResponse() {
    const years = generateYears(2020, new Date().getFullYear());
    const OPERATIONAL_BASE_URL = process.env.REACT_APP_OPERATIONAL_BASE_URL;
    const OPERATIONAL_GET_ID = process.env.REACT_APP_OPERATIONAL_GET_ID;
    const OPERATIONAL_PUT = process.env.REACT_APP_OPERATIONAL_PUT;
    const data = {
        type: "OPERATIONAL",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        communityPartners: {
            businesses: "",
            eduInstitutions: "",
            otherStateAgencies: "",
            others: ""
        },
        associatePresidentName: "",
        associatePresidentEmail: "",
        associateStaffing: {
            total: 0,
            employment: []
        },
        volunteerHours: "",
        documents: [],
        remarks: "",
        acknowledge: false


    }

    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const profile = JSON.parse(storedUser);
            setUserRole(profile.role);
        }
    }, []);

    let { id } = useParams();
    useEffect(() => {
        const recordId = id;
        console.log(recordId);
        const url = OPERATIONAL_BASE_URL + recordId + OPERATIONAL_GET_ID;
        console.log(url);
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setFormData(data);
            })
    }, []);

    const [formData, setFormData] = useState(data);


    const navigate = useNavigate();
    const [saveShow, setSaveShow] = useState(false);
    const handleClose = () => setSaveShow(false);
    const handleShow = () => setSaveShow(true);

    const handleApprove = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "APPROVED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };
    const handleReject = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "REJECTED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = OPERATIONAL_BASE_URL + formData._id + OPERATIONAL_PUT;
        // Call REST API to store the data
        axios.put(url, formData
        ).then((response) => {
            console.log(response.status, response.data);
            setFormData(data);
            navigate("/operationalView");
        }).catch((error) => {
            console.log(error);
        });
    }

    const formatFileSize = (bytes) => {
        if (bytes == undefined || bytes === 0)
            return '0 Bytes';
        else {
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)));
            return Math.round(100 * (bytes / Math.pow(k, i))) / 100 + ' ' + sizes[i];
        }
    }
    const downloadDocument = (doc) => {
        console.log(doc);
        const content = new Blob([new Uint8Array(doc.file.data)], { type: doc.file.type });
        const downlodURL = URL.createObjectURL(content);
        console.log(downlodURL);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', downlodURL);
        link.setAttribute('download', doc.file.name);
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = (doc) => {
        return () => downloadDocument(doc);
    };

    return (
        <>

            <span ><b>Operational Data</b> </span>

            <div className="main-content">
                <Form className="main-content" onSubmit={handleSubmit}>
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="formGridEmail" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="Select" name="siteName" value={formData.siteName} disabled >
                                <option>Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select defaultValue="" name="year" required value={formData.year} disabled>

                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="Choose..." name="month" value={formData.month} disabled >
                                <option>Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>


                    <Row className="main-content">
                        {/* Major community Partners */}
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Major community Partners</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="businesses">
                                            <Form.Label>Businesses</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Businesses" name="communityPartners.businesses" value={formData.communityPartners.businesses} disabled />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="eduInstitutions">
                                            <Form.Label>Educational Institutions</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Educational Institutions" name="communityPartners.eduInstitutions" value={formData.communityPartners.eduInstitutions} disabled />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="otherStateAgencies">
                                            <Form.Label>Other State Agencies</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Other State Agencies" name="communityPartners.otherStateAgencies" value={formData.communityPartners.otherStateAgencies} disabled />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="others">
                                            <Form.Label>Others</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Others" name="communityPartners.others" value={formData.communityPartners.others} disabled />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Associate President</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="presidentName">
                                            <Form.Label>Name of Associate President</Form.Label>
                                            <Form.Control name="associatePresidentName" required value={formData.associatePresidentName} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="email">
                                            <Form.Label>Email of Associate President</Form.Label>
                                            <Form.Control name="associatePresidentEmail" value={formData.associatePresidentEmail} disabled />
                                        </Form.Group>
                                        <Col></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* Associate Staffing */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Associate Staffing</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Table bordered striped hover >
                                            <thead>
                                                <tr>
                                                    <th>Employment Type</th>
                                                    <th>Job Title</th>
                                                    <th>Number of Staffs</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    formData.associateStaffing.employment.map((input, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{input.employmentType}</td>
                                                                <td>{input.jobTitle}</td>
                                                                <td>{input.noOfStaffs}</td>
                                                                <td ><Button variant="transparent" > <FaEdit /></Button>
                                                                    <Button variant="transparent" > <FaTrash /></Button></td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody></Table>


                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/*  Documents Upload */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Documents Upload</Card.Title>
                                    <Row className="main-content" >
                                        <Table striped hover >
                                            <thead>
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>FileName</th>
                                                    <th>Size</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    formData.documents.map((data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{data.documentType} </td>
                                                                <td>{data.file.name}</td>
                                                                <td>{formatFileSize(data.file.size)}</td>
                                                                <td ><Button variant="transparent" onClick={createDownloadHandler(data)}><FaDownload /> </Button>
                                                                    <Button variant="transparent" > <FaTrash /></Button></td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </Table>

                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Remarks</Card.Title>
                                    <Form.Group as={Col} controlId="remarks">
                                        <InputGroup>
                                            <Form.Control as="textarea" aria-label="Remarks" name="remarks" value={formData.remarks} disabled />
                                        </InputGroup>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    {userRole && userRole !== 'OBSERVER' &&
                        <Row className="mb-3 main-content">

                            <Col>
                                <Row className="mb-3 submit">
                                    <Col>

                                        {formData.status !== 'APPROVED' && (
                                            <Col>
                                                <Button variant="primary" className="m-1" onClick={handleApprove}>Approve</Button>
                                            </Col>
                                        )}

                                        <Button variant="primary" type="submit" name="submit" onClick={handleReject}>
                                            Reject
                                        </Button>

                                    </Col>
                                </Row>
                            </Col>


                            <Col />
                            <Col />
                            <Col />
                        </Row>
                    }
                </Form>
            </div >
        </>
    );
}